<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="等级名称" prop="levelName">
          <a-input v-model="form.levelName" placeholder="请输入等级名称" />
        </a-form-model-item>

        <a-form-model-item label="等级排序" prop="sort">
          <a-input-number v-model="form.sort" :min="1" :max="999" placeholder="请输入等级排序" style="width: 100%" />

        </a-form-model-item>

        <a-form-model-item label="购买价格" prop="price">
          <a-input-number v-model="form.price" :min="0" :precision="2" :step="1" placeholder="请输入购买价格" style="width: 100%" />

        </a-form-model-item>

        <a-form-model-item label="有效期(天)" prop="durationDays">
          <a-input-number v-model="form.durationDays" :min="1" :max="3650" placeholder="请输入有效期" style="width: 100%" />

        </a-form-model-item>

<!--        <a-form-model-item label="赠送金额" prop="giveAmount">-->
<!--          <a-input-number v-model="form.giveAmount" :min="0" :precision="2" :step="1" placeholder="请输入赠送金额" style="width: 100%" />-->

<!--        </a-form-model-item>-->

<!--        <a-form-model-item label="分销奖励" prop="commissionAmount">-->
<!--          <a-input-number v-model="form.commissionAmount" :min="0" :precision="2" :step="1" placeholder="请输入分销奖励" style="width: 100%" />-->

<!--        </a-form-model-item>-->

        <a-form-model-item label="等级描述" prop="description">
          <a-textarea v-model="form.description" :rows="4" placeholder="请输入等级描述" />
        </a-form-model-item>

        <a-form-model-item label="商品分类折扣">
          <a-button type="primary" @click="addCategoryDiscount">
            <a-icon type="plus" />添加分类折扣
          </a-button>
          <a-table
            :columns="categoryColumns"
            :data-source="form.categoryDiscounts"
            :pagination="false"
            size="small"
            style="margin-top: 10px"
            :scroll="{ y: 200 }"
          >
            <span slot="categoryId" slot-scope="text, record, index">
              <a-select v-model="record.categoryId" placeholder="请选择商品分类" style="width: 100%">
                <a-select-option v-for="cat in categoryList" :key="cat.id" :value="cat.id">
                  {{ cat.categoryName }}
                </a-select-option>
              </a-select>
            </span>
            <span slot="discountType" slot-scope="text, record, index">
              <a-select v-model="record.discountType" placeholder="请选择折扣类型" style="width: 100%" @change="(val) => handleDiscountTypeChange(record, val)">
                <a-select-option :value="1">PLUS会员价</a-select-option>
                <a-select-option :value="2">折扣比例</a-select-option>
              </a-select>
            </span>
            <span slot="discount" slot-scope="text, record, index">
              <a-input-number
                v-if="record.discountType == 2"
                v-model="record.discount"
                :min="1"
                :max="100"
                placeholder="折扣比例"
                style="width: 100%"
              />
            </span>
            <span slot="action" slot-scope="text, record, index">
              <a @click="removeCategoryDiscount(index)">
                <a-icon type="delete" />删除
              </a>
            </span>
          </a-table>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { add, edit, detail } from '@/api/plus/plusLevel'
import { getFirstLevelCategory } from '@/api/goods/category'

export default {
  name: 'PlusLevelForm',
  data() {
    return {
      title: '新增会员等级',
      visible: false,
      confirmLoading: false,
      categoryList: [],
      categoryColumns: [
        {
          title: '商品分类',
          dataIndex: 'categoryId',
          scopedSlots: { customRender: 'categoryId' },
          width: 100
        },
        {
          title: '折扣类型',
          dataIndex: 'discountType',
          scopedSlots: { customRender: 'discountType' },
          width: 100,
          align: 'center'
        },
        {
          title: '折扣(%)',
          dataIndex: 'discount',
          scopedSlots: { customRender: 'discount' },
          width: 120,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: 80,
          align: 'center'
        }
      ],
      form: {
        id: null,
        levelName: null,
        sort: 1,
        price: null,
        durationDays: 365,
        giveAmount: 0,
        commissionAmount: 0,
        description: null,
        categoryDiscounts: []
      },
      rules: {
        levelName: [{ required: true, message: '请输入等级名称', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入等级排序', trigger: 'blur' }],
        price: [{ required: true, message: '请输入购买价格', trigger: 'blur' }],
        durationDays: [{ required: true, message: '请输入有效期', trigger: 'blur' }],
        giveAmount: [{ required: true, message: '请输入赠送金额', trigger: 'blur' }],
        commissionAmount: [{ required: true, message: '请输入分销奖励', trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 获取商品分类列表
    getCategoryList() {
      console.log('开始获取一级商品分类列表...')
      getFirstLevelCategory().then(response => {
        console.log('一级商品分类接口返回:', response)
        if (response && response.data) {
          this.categoryList = response.data || []
          console.log('一级分类列表:', this.categoryList)
        } else {
          this.categoryList = []
          console.warn('分类数据格式异常, response:', response)
        }
      }).catch(error => {
        console.error('获取一级商品分类失败:', error)
        this.$message.error('获取商品分类失败: ' + (error.message || error))
        this.categoryList = []
      })
    },
    // 新增
    handleAdd() {
      this.title = '新增会员等级'
      this.visible = true
      this.form = {
        id: null,
        levelName: null,
        sort: 1,
        price: null,
        durationDays: 365,
        giveAmount: 0,
        commissionAmount: 0,
        description: null,
        categoryDiscounts: []
      }
      this.getCategoryList()
    },
    // 修改
    handleUpdate(row, ids) {
      this.title = '修改会员等级'
      this.visible = true
      this.getCategoryList()
      
      const id = row ? row.id : ids[0]
      detail(id).then(response => {
        const data = response.data
        console.log('会员等级详情数据:', data)
        this.form = {
          id: data.id,
          levelName: data.levelName,
          sort: data.sort,
          price: data.price,
          durationDays: data.durationDays,
          giveAmount: data.giveAmount,
          commissionAmount: data.commissionAmount,
          description: data.description,
          categoryDiscounts: data.categoryDiscountInfoList ? data.categoryDiscountInfoList.map(item => ({
            categoryId: item.categoryId,
            discountType: item.discountType != null ? Number(item.discountType) : 1,
            discount: item.discount
          })) : []
        }
        console.log('表单数据:', this.form)
      })
    },
    // 提交
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.confirmLoading = true

          console.log('提交前的categoryDiscounts:', this.form.categoryDiscounts)

          // 将元转换为分
          const submitData = {
            ...this.form,
            price: this.form.price ,
            giveAmount: this.form.giveAmount ,
            commissionAmount: this.form.commissionAmount,
            categoryDiscountJson: JSON.stringify(this.form.categoryDiscounts)
          }

          console.log('提交的categoryDiscountJson:', submitData.categoryDiscountJson)

          const promise = this.form.id ? edit(submitData) : add(submitData)

          promise.then(() => {
            this.$message.success(this.form.id ? '修改成功' : '新增成功')
            this.visible = false
            this.$emit('ok')
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    // 取消
    handleCancel() {
      this.visible = false
    },
    // 添加分类折扣
    addCategoryDiscount() {
      this.$set(this.form.categoryDiscounts, this.form.categoryDiscounts.length, {
        categoryId: undefined,
        discountType: 2,
        discount: 90
      })
    },
    // 删除分类折扣
    removeCategoryDiscount(index) {
      this.form.categoryDiscounts.splice(index, 1)
    },
    // 折扣类型改变
    handleDiscountTypeChange(record, value) {
      console.log('折扣类型改变:', record, value)
      if (parseInt(value) === 1) {
        this.$set(record, 'discount', undefined)
      }
    }
  },
  created() {
    // 预加载商品分类
    this.getCategoryList()
  }
}
</script>
